import { Box, Icon, Link } from '@nimbus-ds/components';
import { ExternalLinkIcon } from '@nimbus-ds/icons';
import { HelpLink } from '@nimbus-ds/patterns';
import {
  DEFAULT_LANGUAGE,
  HELP_LINKS_CUSTOMERS_MESSAGES,
} from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import { useIsMobileDevice } from 'domains/Auth/hooks';
import { useTranslationCustomers } from 'domains/Customers/hooks';

export default function MessagesListHelpLink(): JSX.Element | null {
  const language = useTranslationLanguage();
  const t = useTranslationCustomers();

  const isMobile = useIsMobileDevice();

  const helpHref =
    HELP_LINKS_CUSTOMERS_MESSAGES[language] ??
    HELP_LINKS_CUSTOMERS_MESSAGES[DEFAULT_LANGUAGE];

  if (isMobile) return null;

  return (
    <Box display="flex" justifyContent="center">
      <HelpLink>
        <Link
          as="a"
          href={helpHref}
          target="_blank"
          appearance="primary"
          textDecoration="none"
          rel="noopener noreferrer"
        >
          {t('messages.emptyResults.canText')}
          <Icon
            source={<ExternalLinkIcon />}
            color="currentColor"
            aria-hidden="true"
          />
        </Link>
      </HelpLink>
    </Box>
  );
}
